import { useLocation } from 'react-router-dom';
import { canOpenStandalone, openStandaloneTab } from '../../lib/standaloneChrome';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/Tooltip';

export function OpenStandaloneButton() {
  const location = useLocation();
  // Emplacement réservé : sans nouvel onglet, la place reste vide et le
  // chrono, la cloche et l'avatar ne bougent pas.
  if (!canOpenStandalone(location.pathname)) {
    return <span className="w-9 h-9 flex-shrink-0" aria-hidden />;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => openStandaloneTab(`${location.pathname}${location.search}`)}
          aria-label="Ouvrir dans un nouvel onglet"
          className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg text-neutral-500 hover:text-neutral-700 hover:bg-neutral-100 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="w-[18px] h-[18px]"
            fill="currentColor"
            aria-hidden
          >
            {/* Font Awesome Pro 6.5.1 — square-arrow-up-right regular */}
            <path d="M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z" />
          </svg>
        </button>
      </TooltipTrigger>
      <TooltipContent>Ouvrir dans un nouvel onglet — sans menu de navigation</TooltipContent>
    </Tooltip>
  );
}
